import $pulse from 'stores/pulse'
import $tracker from 'stores/tracker'

export function getPulseStore(store_id) {
  // Depending on the pulse tab, we can receive different types of store in rightbar (signal or tracker)
  // so we need to get correct user company id from it (field user_entity_id), and company meta data also
  const store =  $tracker.getItem(store_id) || $pulse.getItem(store_id)
  return store
}

export function sliderFocus(){
  return {
    get() {
      if (this.tracker_focus === 'high') return 0
      if (this.tracker_focus === 'balanced') return 50
      else return 100
    }, 
    set(val) {
      if (val >= 0 && val < 33.33) {
        this.tracker_focus = 'high'
      } else if (val >= 33.33 && val < 66.66) {
        this.tracker_focus = 'balanced'
      } else if (val >= 66.66 && val <= 100) {
        this.tracker_focus = 'all'
      }
    }
  }
}

function getToday(){
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}

function getRange(days_ago) {
  const today = getToday()
  const from = new Date(today)
  from.setDate(from.getDate() - (days_ago - 1))

  const to = new Date(today)
  to.setHours(23, 59, 59, 999)

  return [from.toISOString(), to.toISOString()]
}

export const DATES = [
  {
    title: 'Today',
    value: 'today',
    get date() {
      const today = getToday()
      return [today.toISOString(), undefined]
    }
  },
  {
    title: 'Yesterday',
    value: 'yesterday',
    get date() {
      const yesterday = getToday()
      yesterday.setDate(yesterday.getDate() - 1)
      const end_yesterday = new Date(yesterday)
      end_yesterday.setHours(23, 59, 59, 999)
      return [yesterday.toISOString(), end_yesterday.toISOString()]
    }
  },
  {
    title: 'Last 3 days',
    value: 'last_3_days',
    get date() {
      return getRange(3)
    }
  },
  {
    title: 'Last 7 days',
    value: 'last_7_days',
    get date() {
      return getRange(7)
    }
  },
  {
    title: 'Last 30 days',
    value: 'last_30_days',
    get date() {
      return getRange(30)
    }
  },
  {
    title: 'All Time',
    value: 'all_time',
    get date() {
      return undefined
    }
  }
]

const TOOLTIPS = [
  {
    value: 'relationship',
    title: 'Company relationship',
    content: 'Define how this company relates to your business to help prioritize relevant signals.'
  },
  {
    value: 'signal_sensitivity',
    title: 'Signal sensitivity',
    content: 'Control how selective the tracker is when showing signals, from only major developments to all activity.'
  },
  {
    value: 'company_customize_tracking',
    title: 'Customize signal focus',
    content: 'Add topics or developments you want the tracker to prioritize for this company.'
  },
  {
    value: 'topic_customize_tracking',
    title: 'Customize signal focus',
    content: 'Add developments you want the tracker to prioritize for this topic.'
  },
  {
    value: 'contact_customize_tracking',
    title: 'Customize signal focus',
    content: 'Add topics or developments you want the tracker to prioritize for this contact.'
  },
  {
    value: 'email_notifications',
    title: 'Email notifications',
    content: 'Choose when you want to receive email updates for signals from this tracker.'
  },
  {
    value: 'people_tracking',
    title: 'Tracked people',
    content: 'Follow key individuals at this company and highlight signals related to their activity.'
  }
]

export const getTooltip = tooltip => {
  const tooltip_lc = tooltip.toLowerCase()
  return TOOLTIPS.find(t => t.value === tooltip_lc)
}
